import React, {useEffect, useMemo, useState} from 'react';
import {
  Box,
  Button,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
  Paper,
  FormControl,
  InputLabel,
  IconButton,
  Alert,
  Snackbar
} from '@mui/material';
import {Delete} from '@mui/icons-material';
import {useForm, useFieldArray, Controller} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers/yup';
import * as yup from 'yup';
import {getValue, maxHeight, Stack} from '@mui/system';
import {DatePicker, DesktopDatePicker} from '@mui/x-date-pickers';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns';
import SnackBarConfig from '@components/snackbar/SnackbarConfig';
import SelectInput from '@components/form/select-input/SelectInput';
import BasicDatePicker from '@components/form/date-picker/BasicDatePicker';
import {
  getLMSResultsData,
  getSearchResultsData
} from '@shared/services/service-handlers/PrivateService';
import {getErrorMessage} from '@shared/utils/ErrorUtils';
import {enqueueSnackbar} from 'notistack';
import EncryptUtils from 'src/utils/EncryptUtils';
import {FormControlDiv} from '../../module-search-filter/ModuleSearchFilterStyle';
import {useAppContext} from '@context/AppContext';
import {LoadingScreen} from '@components/loading-screen';
import {LoadingButton} from '@mui/lab';
import {FormHelperTextP} from '@components/form/select-input/SelectInputStyle';
import {BASE_RECORD_ID, LMS_IS_ADMIN} from 'src/routes/BaseRoute';
import {useLocation} from 'react-router-dom';
import {format, isValid} from 'date-fns';
import moment from 'moment';
import {useModulePreviewContext} from '@context/ModulePreviewContextProvider';

// Validation schema for entities

interface FormData {
  lockOption: number;
  lockUntil?: Date | null | undefined;
  entities?: {
    entity_id: string | undefined;
    entity_completion_type_id: number | null;
    entity_completion_sub_type_id: string | null;
  }[];
}
interface ModuleData {
  id: string;
  name: string;
  expanded: boolean;
  description?: string;
  duration?: string;
  type: string;
  sequence: number;
  module_lock_type_id?: number;
  locked_until_date?: string;
  Module_Completed?: boolean;
  IsUnlocked?: boolean;
  is_completed?: boolean;
  locked_linked_items?: {
    id: string;
    item_name: string;
    entity_completion_sub_type_id: string;
    module_link_id: string;
    module_id: string;
    type: 'file' | 'link' | 'content' | 'assignment' | 'onlinetest' | 'module';
  }[];
  files?: {
    id: string;
    name: string;
    ParentName: string;
    blob_file_extension?: string;
    fileexpanded: boolean;
    time?: string;
    score?: string;
    lock_type_id: number;
    locked_until_date?: string;
    type: string;
    module_id: string;
    sequence: number;
    ChildItems_Completed?: boolean;
    IsUnlocked?: boolean;
    is_completed?: boolean;
    additionalFiles?: {id: string; name: string}[];
    locked_linked_items?: {
      id: string;
      item_name: string;
      entity_completion_sub_type_id: string;
      module_link_id: string;
      module_id: string;
      type:
        | 'file'
        | 'link'
        | 'content'
        | 'assignment'
        | 'onlinetest'
        | 'module';
    }[];
  }[];
}
interface EntityValue {
  entity_id: string;
  entity_completion_type_id: string | null;
  entity_completion_sub_type_id: string | null;
}
interface DropDownData {
  Name: string;
  Values: {label: string; value: string}[];
}
interface LockPropertiesProps {
  uiFields: any;
  insertdata: any;
  // eslint-disable-next-line react/boolean-prop-naming
  isloader: boolean;
  dropdowndata?: DropDownData[];
}
const createValidationSchema = (formValuess: FormData) => {
  const {lockOption} = formValuess;
  if (lockOption === 2) {
    return yup.object({
      lockOption: yup.number().required(),
      lockUntil: yup.date().required('Lock date is required'),
      entities: yup.array().notRequired()
    });
  }

  if (lockOption === 3) {
    return yup.object({
      lockOption: yup.number().required(),
      lockUntil: yup.date().nullable(),
      entities: yup
        .array()
        .of(
          yup.object({
            entity_id: yup.string().notRequired(),
            entity_completion_type_id: yup
              .number()
              .required('Type is required'),
            entity_completion_sub_type_id: yup
              .string()
              .required('Value is required')
          })
        )
        .min(1, 'At least one entity is required')
        .required()
    });
  }

  return yup.object({
    lockOption: yup.number().required(),
    lockUntil: yup.date().nullable(),
    entities: yup.array().notRequired()
  });
};

const LockProperties: React.FC<LockPropertiesProps> = ({
  uiFields,
  insertdata,
  isloader,
  dropdowndata
}) => {
  const {
    appState: {applicationName}
  } = useAppContext();
  // Initialize React Hook Form
  function useQuery() {
    const {search} = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }
  const query = useQuery();
  const section = query.get('section');
  const subSection = query.get('subsection');
  const uniqueId = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_RECORD_ID
  );
  const lmsisAdmin = EncryptUtils.getDecryptedData(
    location?.search,
    LMS_IS_ADMIN
  );
  const {ModulePreviewData, SetModulePreviewData} = useModulePreviewContext();
  const [lockOption, setLockOption] = useState(1);
  const [saved, setSaved] = useState<boolean>(false);
  const {dropDownData, setDropDownData} = useModulePreviewContext();
  const [entityData, setEntityData] = useState<DropDownData[]>([]);
  // Initialize Form Values
  const [entityValues, setEntityValues] = useState<EntityValue[]>([]);
  const [formValues, setFormValues] = useState<FormData>({
    lockOption: lockOption,
    lockUntil: null,
    entities: [
      {
        entity_id: undefined,
        entity_completion_type_id: null,
        entity_completion_sub_type_id: null
      }
    ]
  });
  const [isloaded, setIsLoaded] = useState(false);
  const [lockproploder, setLockproploader] = useState(false);
  const validationSchema = useMemo(
    () =>
      createValidationSchema({
        lockOption: lockOption,
        lockUntil: null,
        entities: [
          {
            entity_id: undefined,
            entity_completion_type_id: null,
            entity_completion_sub_type_id: null
          }
        ]
      }),
    [lockOption]
  );

  // Initialize React Hook Form
  const methods = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      lockOption: lockOption,
      lockUntil: null,
      entities: []
    }
  });

  const {
    control,
    handleSubmit,
    setValue,
    resetField,
    getValues,
    watch,
    formState: {errors}
  } = methods;
  const {fields, append, remove} = useFieldArray({
    control,
    name: 'entities'
  });
  const generateOptionsList = (fields: any, data: any) => {
    const transformedData = data
      .map((item: {name: any; id: any}) => ({
        label: item.name,
        value: item.id
      }))
      .sort(
        (a: {sequence: number}, b: {sequence: number}) =>
          a.sequence - b.sequence
      );

    return transformedData;
  };
  const findFileInModule = (data: any[], moduleId: any, type: string) => {
    const module = data.find(m => m.id === moduleId);
    return module ?? null;
  };
  const values =
    dropDownData.find(item => item.Name === 'EntityCompletionType')?.Values ||
    [];

  // Your tree data: assume this is coming from your system

  // Normalize function for matching type
  // function normalizeType(type) {
  //   return type.toLowerCase().replace(/_/g, '');
  // }
  // const values = dropDownData.find(d => d.Name === 'EntityCompletionType')?.Values || [];

  const typeMap = new Map(
    values.map(({label, value}) => [
      label.toLowerCase().replace(/\s|_/g, ''),
      value.toString()
    ])
  );
  function extractDropDownDataFromTree(tree: ModuleData[]) {
    const typeIdToItems = new Map();

    for (const module of tree) {
      const modTypeId = typeMap.get(
        module.type?.toLowerCase().replace(/\s|_/g, '')
      );
      if (modTypeId) {
        if (!typeIdToItems.has(modTypeId)) typeIdToItems.set(modTypeId, []);
        if (module.id !== insertdata.data[0].id) {
          typeIdToItems.get(modTypeId).push({
            label: module.name,
            value: module.id
          });
        }
      }

      if (Array.isArray(module.files)) {
        for (const file of module.files) {
          const fileTypeId = typeMap.get(
            file.type?.toLowerCase().replace(/\s|_/g, '')
          );
          if (fileTypeId) {
            if (!typeIdToItems.has(fileTypeId))
              typeIdToItems.set(fileTypeId, []);
            if (file.module_id !== insertdata.data[0].id) {
              typeIdToItems.get(fileTypeId).push({
                label: file.name,
                value: file.id
              });
            }
          }
        }
      }
    }

    return [...typeIdToItems.entries()].map(([Name, Values]) => ({
      Name,
      Values
    }));
  }
  const handleEntityData = async () => {
    try {
      // const operations = 'DropDownData';

      // const {sql_data} = uiFields['EntityCompletionUpload'];
      // datavalue.bloburls = datavalue.bloBurls[0].blobUrl;
      // setScreenSave(true);
      const dropDownResults =
        await extractDropDownDataFromTree(ModulePreviewData);
      // const data: any = {
      //   sql_data: sql_data,
      //   data: {course_overview_id: uniqueId, module_id: insertdata.data[0].id},
      //   operation: operations
      // };
      // const encryptRequestData = EncryptUtils.encryptedData(data);
      // const result = await getLMSResultsData(applicationName, 'LMS', {
      //   tk: encryptRequestData
      // });
      // const transformedData: DropDownData[] = Object.values(
      //   result.data.reduce(
      //     (
      //       acc: {[x: string]: {Name: any; Values: {label: any; value: any}[]}},
      //       curr: {ModuleContentType: any; label: any; value: any}
      //     ) => {
      //       const key = `ModuleContentType ${curr.ModuleContentType}`;
      //       if (!acc[key]) {
      //         acc[key] = {
      //           Name: `${curr.ModuleContentType}`,
      //           Values: []
      //         };
      //       }
      //       acc[key].Values.push({label: curr.label, value: curr.value});
      //       return acc;
      //     },
      //     {} as Record<string, DropDownData>
      //   )
      // );
      setEntityData(dropDownResults);
      return dropDownResults;
    } catch (e) {
      const errMessage = getErrorMessage(e);
      enqueueSnackbar(errMessage, SnackBarConfig.getError());
    }
  };
  const handleLegacyAppChange = async (event: any, name: string) => {
    const {sql_data, order_by, sort_by} = uiFields[name];
    try {
      const data: any = {
        sql_data: sql_data,
        sort: order_by,
        sort_by: sort_by,
        isImportFiles: true
      };
      const encryptRequestData = EncryptUtils.encryptedData(data);
      const result = await getSearchResultsData(applicationName, 'LMS', {
        tk: encryptRequestData
      });
      const new_options = generateOptionsList(
        [{generate_options: true}],
        result?.data
      );
      setDropDownData((prevData: any[]) => {
        const existingEntry = prevData?.find(
          (entry: {Name: string}) => entry.Name === name
        );

        if (existingEntry) {
          // If the Name already exists, update its Values
          return [...prevData];
        }

        // If the Name is new, add it to the array
        return [...prevData, {Name: name, Values: new_options}];
      });
      return new_options;
    } catch (e) {
      const errMessage = getErrorMessage(e);
      enqueueSnackbar(errMessage, SnackBarConfig.getError());
    }
  };

  const init = async () => {
    try {
      setLockproploader(true);
      if (uiFields) {
        const {sql_data} = uiFields['create_sql'];
        let operations;
        if (insertdata) {
          operations = 'SEARCH';
        }
        const data: any = {
          sql_data: sql_data,
          data: {id: insertdata.data[0].id, course_overview_id: uniqueId},
          operation: operations
        };
        const encryptRequestData = EncryptUtils.encryptedData(data);
        const result = await getLMSResultsData(applicationName, 'LMS', {
          tk: encryptRequestData
        });
        if (result.data[0].module_lock_type_id) {
          setLockOption(result.data[0].module_lock_type_id);
          setValue('lockOption', result.data[0].module_lock_type_id);
        }
        if (result.data[0].module_lock_type_id === 2) {
          if (result.data[0].locked_until_date) {
            setValue(
              'lockUntil',
              new Date(
                moment.utc(result.data[0].locked_until_date).toISOString()
              )
            ); // Parse ISO string to Date
          } else {
            setValue('lockUntil', null); // Handle null values
          }
        }
        if (
          result.data[0].module_lock_type_id === 3 &&
          result.data[0].entityfiles.length > 0
        ) {
          const updatedEntities = result.data[0].entityfiles.map(
            (entityFile: {
              entity_id: any;
              entity_completion_type_id: any;
              entity_completion_sub_type_id: any;
            }) => ({
              entity_id: entityFile.entity_id ?? undefined, // Assign entity_id
              entity_completion_type_id:
                entityFile.entity_completion_type_id ?? null, // Assign type_id
              entity_completion_sub_type_id:
                entityFile.entity_completion_sub_type_id?? '' // Assign sub_type_id
            })
          );
          setEntityValues(updatedEntities);
          // Update the form's entities field
          setValue('entities', updatedEntities, {shouldValidate: true});
          await handleEntityData();
          const hasEntityCompletionType = dropDownData.some(
            item => item.Name === 'EntityCompletionType'
          );

          if (!hasEntityCompletionType) {
            await handleLegacyAppChange(
              'EntityCompletionType',
              'EntityCompletionType'
            );
          }
        }
        const hasEntityCompletionType = dropDownData.some(
          item => item.Name === 'lockOption'
        );

        if (!hasEntityCompletionType) {
          await handleLegacyAppChange('lockOption', 'lockOption');
        }
        setLockproploader(false);
      }
    } catch (e) {
      const errMessage = getErrorMessage(e);
      enqueueSnackbar(errMessage, SnackBarConfig.getError());
      setLockproploader(false);
    }
  };
  useEffect(() => {
    const fetchData = async () => {
      const fileData = findFileInModule(
        ModulePreviewData,
        insertdata.data[0].id,
        insertdata.data[0].type
      );
      if (fileData !== undefined && fileData !== null) {
        setLockproploader(true);
        if (fileData?.module_lock_type_id) {
          setLockOption(fileData.module_lock_type_id);
          setValue('lockOption', fileData.module_lock_type_id);
        }
        if (fileData.module_lock_type_id === 2) {
          if (fileData.locked_until_date) {
            setValue(
              'lockUntil',
              new Date(moment.utc(fileData.locked_until_date).toISOString())
            ); // Parse ISO string to Date
          } else {
            setValue('lockUntil', null); // Handle null values
          }
        }
        if (
          fileData.module_lock_type_id === 3 &&
          fileData?.locked_linked_items.length > 0
        ) {
          const updatedEntities = fileData.locked_linked_items.map(
            (entityFile: {
              id: any;
              entity_completion_type_id: any;
              entity_completion_sub_type_id: any;
            }) => ({
              entity_id: entityFile.id ?? undefined, // Assign entity_id
              entity_completion_type_id:
                entityFile.entity_completion_type_id ?? null, // Assign type_id
              entity_completion_sub_type_id:
                entityFile.entity_completion_sub_type_id ?? null // Assign sub_type_id
            })
          );
          setEntityValues(updatedEntities);
          // Update the form's entities field
          setValue('entities', updatedEntities, {shouldValidate: true});
          // `dropDownData` is assumed to be the array you showed above.
          const hasEntityCompletionType = dropDownData.some(
            item => item.Name === 'EntityCompletionType'
          );

          if (!hasEntityCompletionType) {
            await handleLegacyAppChange(
              'EntityCompletionType',
              'EntityCompletionType'
            );
          }
          handleEntityData();
        }
        const hasEntityCompletionType = dropDownData.some(
          item => item.Name === 'lockOption'
        );

        if (!hasEntityCompletionType) {
          await handleLegacyAppChange('lockOption', 'lockOption');
        }
        handleEntityData();
        setLockproploader(false);
      } else {
        await init();
      }
    };

    fetchData();
  }, []);

  const handleSnackbarClose = () => {
    // setOpenSnackbar(false);
    setSaved(false);
  };
  //   const [lockUntil, setLockUntil] = React.useState();
  // Handle form submission
  const onSubmit = async (datavalue: any) => {
    try {
      if (uiFields) {
        const dataform = {...datavalue};
        const {sql_data} = uiFields['create_sql'];
        dataform.id = insertdata.data[0].id;
        dataform.courseoverviewid = uniqueId;
        dataform.isAdmin = lmsisAdmin === 'True';
        dataform.page = 2;
        // dataform.lockUntil = format(dataform.lockUntil, 'yyyy-MM-dd');
        setIsLoaded(true);
        const data: any = {
          sql_data: sql_data,
          data: dataform,
          operation: 'UPDATE'
        };
        const encryptRequestData = EncryptUtils.encryptedData(data);
        const result = await getLMSResultsData(applicationName, 'LMS', {
          tk: encryptRequestData
        });
        const processModulesData = (data: ModuleData[]) => {
          return data.map(module => ({
            ...module,
            files:
              module.files?.map(file => ({
                ...file,
                locked_linked_items:
                  typeof file.locked_linked_items === 'string'
                    ? JSON.parse(file.locked_linked_items) // 🛠️ Parse if string
                    : file.locked_linked_items || [], // Keep array or default to empty
                additionalFiles:
                  typeof file.additionalFiles === 'string'
                    ? JSON.parse(file.additionalFiles) // 🛠️ Parse if string
                    : file.additionalFiles || [] // Keep array or default to empty
              })) || []
          }));
        };
        const syncExpandedStates = (
          transformed: ModuleData[],
          existing: ModuleData[]
        ) => {
          return transformed.map(module => {
            const matchingModule = existing.find(e => e.id === module.id);

            if (!matchingModule) return module;

            // Sync the `expanded` flag
            const updatedModule = {
              ...module,
              expanded: matchingModule.expanded || false,
              files:
                module?.files &&
                module?.files.map(file => {
                  const matchingFile =
                    matchingModule?.files &&
                    matchingModule.files.find(f => f.id === file.id);
                  return {
                    ...file,
                    fileexpanded: matchingFile?.fileexpanded || false
                  };
                })
            };

            return updatedModule;
          });
        };
        if (getValues('lockOption') === 3) {
          const {sql_data} = uiFields['EntityCompletionUpload'];
          const dataUploadForm = {...datavalue}; // Clone datavalue for lockOption-specific logic

          // Ensure id is not added for lockOption === 3
          delete dataUploadForm.id;
          dataUploadForm.course_overview_id = uniqueId;
          dataUploadForm.module_id = insertdata.data[0].id; // Add module_id instead
          setIsLoaded(true);
          // const datas: any = {
          //   sql_data: sql_data,
          //   data: {module_id: id.data[0].id},
          //   operation: 'SEARCH',
          //   dataUpload: 'Multiple'
          // };
          // const encryptRequestDatas = EncryptUtils.encryptedData(datas);
          // const result = await getLMSResultsData(applicationName, 'LMS', {
          //   tk: encryptRequestDatas
          // });
          let deleteData;
          const entities = watch('entities'); // Get current entities from the form
          if (entityValues !== undefined) {
            if (entities && entityValues && entityValues?.length > 0) {
              const updatedEntities = entities.map(entity => {
                // Find matches in the result array
                const match = entityValues?.find(res => {
                  if (
                    !res?.entity_completion_sub_type_id ||
                    !res?.entity_completion_type_id ||
                    !res?.entity_id
                  ) {
                    return false;
                  }
                  return (
                    res?.entity_completion_sub_type_id ===
                      entity?.entity_completion_sub_type_id &&
                    res?.entity_completion_type_id ===
                      entity?.entity_completion_type_id &&
                    res?.entity_id === entity?.entity_id
                  );
                });

                // If a match is found, update entity_id
                // if (match) {
                //   return {
                //     ...entity,
                //     entity_id: match.entity_id
                //   };
                // }

                // Otherwise, return the entity as is
                return entity;
              });

              const entitiesToDelete = entityValues?.filter((res: any) => {
                // Check if the entity ID exists in the current entities list
                return !updatedEntities.some(
                  entity => entity?.entity_id === res?.entity_id
                );
              });

              // Update entities for deletion
              deleteData = entitiesToDelete.map(res => ({
                entity_id: res?.entity_id,
                deleted: true
              }));

              // Existing records without deleted flag

              // Use setValue to update the entities field
              setValue('entities', updatedEntities, {shouldValidate: true});
            }
          }
          const insertData = entities?.filter(entity => !entity.entity_id); // New records without an ID
          const updateData = entities?.filter(
            entity => entity.entity_id && !entity.deleted
          ); // Existing records with modifications
          // const deleteData = entities?.filter(entity => entity.deleted); // Records marked for deletion

          // Perform INSERT operations
          if (insertData && insertData?.length > 0) {
            const cleanedInsertData = insertData.map(item => ({
              ...item,
              course_overview_id: uniqueId,
              isAdmin: lmsisAdmin === 'True',
              module_id: insertdata.data[0].id // Add module_id
            }));
            const insertRequest: any = {
              sql_data: sql_data,
              data: {
                entity: JSON.stringify(insertData),
                course_overview_id: uniqueId,
                isAdmin: lmsisAdmin === 'True',
                module_id: insertdata.data[0].id
              },
              operation: 'INSERT',
              dataUpload: 'Multiple'
            };
            const insertEncryptRequest =
              EncryptUtils.encryptedData(insertRequest);
            const insertResult = await getLMSResultsData(
              applicationName,
              'LMS',
              {
                tk: insertEncryptRequest
              }
            );
            const transformData = await processModulesData(
              insertResult.module_data
            );
            const updatedTransformed = syncExpandedStates(
              transformData,
              ModulePreviewData
            );
            await SetModulePreviewData(updatedTransformed);
            const entities = watch('entities'); // Get current entities from the form
            if (entities) {
              const updatedEntities = entities.map(entity => {
                // Find matches in the result array
                const match = insertResult.data.find(
                  (res: {entity_id: any}) => {
                    return (
                      res.entity_id === entity.entity_id || !entity.entity_id
                    );
                  }
                );

                // If a match is found, update entity_id
                if (match) {
                  return {
                    ...entity,
                    entity_id: match.entity_id
                  };
                }

                // Otherwise, return the entity as is
                return entity;
              });
              setEntityValues(updatedEntities);
              // Use setValue to update the entities field
              await setValue('entities', updatedEntities, {
                shouldValidate: true
              });
            }
          }

          // Perform UPDATE operations
          if (updateData && entities && updateData?.length > 0) {
            const cleanedUpdateData = updateData.map(
              ({entity_id, ...rest}) => ({
                entity_id,
                course_overview_id: uniqueId,
                isAdmin: lmsisAdmin === 'True', // Only keep required fields
                ...rest
              })
            );
            const updateRequest: any = {
              sql_data: sql_data,
              data: {
                entity: JSON.stringify(updateData),
                course_overview_id: uniqueId,
                isAdmin: lmsisAdmin === 'True'
              },
              operation: 'UPDATE',
              dataUpload: 'Multiple'
            };
            const updateEncryptRequest =
              EncryptUtils.encryptedData(updateRequest);
            const updateResult = await getLMSResultsData(
              applicationName,
              'LMS',
              {
                tk: updateEncryptRequest
              }
            );
            // setEntityValues(entities);
            const transformData = await processModulesData(
              updateResult.module_data
            );
            const updatedTransformed = syncExpandedStates(
              transformData,
              ModulePreviewData
            );
            await SetModulePreviewData(updatedTransformed);
          }

          // Perform DELETE operations
          if (deleteData && deleteData?.length > 0) {
            const cleanedDeleteData = deleteData.map(({entity_id}) => ({
              entity_id,
              course_overview_id: uniqueId, // Only send entity_id for deletion
              isAdmin: lmsisAdmin === 'True'
            }));
            const deleteRequest: any = {
              sql_data: sql_data,
              data: {
                entity: JSON.stringify(deleteData),
                course_overview_id: uniqueId,
                isAdmin: lmsisAdmin === 'True'
              },
              operation: 'DELETE',
              dataUpload: 'Multiple'
            };
            const deleteEncryptRequest =
              EncryptUtils.encryptedData(deleteRequest);
            const deleteResult = await getLMSResultsData(
              applicationName,
              'LMS',
              {
                tk: deleteEncryptRequest
              }
            );
            const transformData = await processModulesData(
              deleteResult.module_data
            );
            const updatedTransformed = syncExpandedStates(
              transformData,
              ModulePreviewData
            );
            await SetModulePreviewData(updatedTransformed);
            if (entities) {
              setEntityValues(entities);
            } else {
              setEntityValues([]);
            }
          }
        }
        if (getValues('lockOption') === 1 || getValues('lockOption') === 2) {
          if (result.data[1]) {
            const transformData = await processModulesData(result.data[1]);
            const updatedTransformed = syncExpandedStates(
              transformData,
              ModulePreviewData
            );
            await SetModulePreviewData(updatedTransformed);
          }
        }
        setIsLoaded(false);
        setSaved(true);
      }
    } catch (e) {
      const errMessage = getErrorMessage(e);
      enqueueSnackbar(errMessage, SnackBarConfig.getError());
      setIsLoaded(false);
    }
    // handleLockProperties(data)
  };
  return lockproploder ? (
    <Stack
      display={'flex'}
      justifyContent={'center'}
      alignItems={'center'}
      minHeight={'50vh'}>
      <LoadingScreen />
    </Stack>
  ) : (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <form
        onSubmit={handleSubmit(onSubmit)}
        style={{maxHeight: '67vh', overflowY: 'auto'}}>
        <Grid container spacing={3}>
          {/* Module Lock Description */}
          <Grid item xs={12}>
            <Typography variant="h6">Module Lock</Typography>
            <Typography variant="body2">
              Specify when this module is to be unlocked and made available for
              learner.
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Controller
              name="lockOption"
              control={control}
              render={({field: {value, onChange}}) => (
                <FormControlDiv>
                  <SelectInput
                    enableDefaultOption
                    name="lockOption"
                    options={
                      dropDownData.find(item => item.Name === 'lockOption')
                        ?.Values || []
                    }
                    value={value || lockOption}
                    fullWidth
                    onOpenCallback={(event: any) =>
                      handleLegacyAppChange(event, 'lockOption')
                    }
                    onChange={(event: any) => {
                      onChange(event);
                      setLockOption(Number(event.target.value));
                      resetField('lockUntil');
                      resetField('entities');
                      // setState(prevState => ({
                      //   ...prevState,
                      //   formError: ''
                      // }));
                    }}
                    optionValueKey={'value'}
                    optionLabelKey={'label'}
                    fetchOptionsFromOnOpenTrigger
                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxHeight: '30vh', // Set dropdown max height
                          overflowY: 'auto' // Enable scrolling
                        }
                      }
                    }}
                  />
                </FormControlDiv>
              )}
            />
          </Grid>

          {/* Entity Selection */}
          {lockOption === 3 && (
            <Grid item xs={12}>
              <Typography variant="h6">Select Entity</Typography>
              <Typography variant="body2" sx={{mb: 2}}>
                The course entity will be unlocked on successful completion of
                the entities selected below.
              </Typography>

              {fields.map((field, index) => (
                <Paper
                  key={index}
                  sx={{
                    p: 2,
                    m: 1,
                    backgroundColor: '#f9f9f9',
                    border: '1px solid #e0e0e0'
                  }}>
                  <Grid
                    container
                    spacing={2}
                    key={field.id}
                    alignItems="center">
                    {/* Entity Type */}
                    {/* <Grid item xs={4}>
                      <FormControl fullWidth style={{backgroundColor: 'white'}}>
                        <InputLabel>Type</InputLabel>
                        <Controller
                          name={`entities.${index}.type` as const}
                          control={control}
                          render={({field}) => (
                            <Select
                              {...field}
                              error={!!errors.entities?.[index]?.type}
                              label="Type">
                              <MenuItem value="File">File</MenuItem>
                              <MenuItem value="Quiz">Quiz</MenuItem>
                              <MenuItem value="Assignment">Assignment</MenuItem>
                              <MenuItem value="Video">Video</MenuItem>
                            </Select>
                          )}
                        />
                        {errors.entities?.[index]?.type && (
                          <Typography variant="caption" color="error">
                            {console.log('errors', errors.entities[index])}
                            {errors.entities[index].type?.message}
                          </Typography>
                        )}
                      </FormControl>
                    </Grid> */}
                    <Grid item xs={4}>
                      <Controller
                        name={
                          `entities.${index}.entity_completion_type_id` as const
                        }
                        control={control}
                        defaultValue={field?.default}
                        render={({field: {value, onChange}}) => (
                          <FormControlDiv>
                            <SelectInput
                              sx={{
                                maxWidth: '30vh',
                                maxHeight: '30vh',
                                backgroundColor: 'white'
                              }}
                              name={
                                `entities.${index}.entity_completion_type_id` as const
                              }
                              options={
                                dropDownData.find(
                                  item => item.Name === 'EntityCompletionType'
                                )?.Values || []
                              }
                              label="select"
                              value={value || ''}
                              fullWidth
                              onOpenCallback={(event: any) =>
                                handleLegacyAppChange(
                                  event,
                                  'EntityCompletionType'
                                )
                              }
                              onChange={(event: any) => {
                                onChange(event);
                                setValue(
                                  `entities.${index}.entity_completion_sub_type_id`,
                                  null
                                );
                                // setState(prevState => ({
                                //   ...prevState,
                                //   formError: ''
                                // }));
                              }}
                              optionValueKey={'value'}
                              optionLabelKey={'label'}
                              fetchOptionsFromOnOpenTrigger
                              onChangeCallback={(event: any) =>
                                console.log('eve', event)
                              }
                              MenuProps={{
                                PaperProps: {
                                  style: {
                                    maxHeight: '30vh', // Set dropdown max height
                                    overflowY: 'auto' // Enable scrolling
                                  }
                                }
                              }}
                            />
                          </FormControlDiv>
                        )}
                      />
                    </Grid>
                    <Grid item xs={1}>
                      <Typography
                        sx={{display: 'flex', justifyContent: 'center'}}>
                        is
                      </Typography>
                    </Grid>
                    {/* Entity Value */}
                    <Grid item xs={6}>
                      <Controller
                        name={
                          `entities.${index}.entity_completion_sub_type_id` as const
                        }
                        control={control}
                        render={({field: {value, onChange}}) => {
                          const entityCompletionTypeId = watch(
                            `entities.${index}.entity_completion_type_id`
                          );

                          // Get all options based on `entityCompletionTypeId`
                          const allOptions =
                            entityData.find(
                              item =>
                                item.Name === String(entityCompletionTypeId)
                            )?.Values || [];
                          // Exclude currently selected values from the options
                          const selectedValues = watch('entities') // Watch all entities
                            ?.filter((_, i) => i !== index) // Exclude the current entity
                            .map(e => e.entity_completion_sub_type_id); // Extract selected values

                          const filteredOptions = allOptions.filter(
                            option => !selectedValues?.includes(option.value)
                          );
                          return (
                            <FormControlDiv>
                              <SelectInput
                                sx={{
                                  maxHeight: '30vh',
                                  backgroundColor: 'white'
                                }}
                                name={
                                  `entities.${index}.entity_completion_sub_type_id` as const
                                }
                                options={filteredOptions}
                                label="select"
                                value={value || ''}
                                fullWidth
                                onOpenCallback={(event: any) =>
                                  handleEntityData()
                                }
                                onChange={(event: any) => {
                                  onChange(event);
                                }}
                                optionValueKey={'value'}
                                optionLabelKey={'label'}
                                fetchOptionsFromOnOpenTrigger
                                onChangeCallback={(event: any) =>
                                  console.log('eve', event)
                                }
                                error={
                                  !!(errors.entities?.[index] as any)
                                    ?.entity_completion_sub_type_id?.message
                                }
                                MenuProps={{
                                  PaperProps: {
                                    style: {
                                      maxHeight: '30vh', // Set dropdown max height
                                      overflowY: 'auto' // Enable scrolling
                                    }
                                  }
                                }}
                              />
                            </FormControlDiv>
                          );
                        }}
                      />
                    </Grid>

                    {/* Delete Button */}
                    {fields.length > 1 && index != 0 && (
                      <Grid item xs={1}>
                        <IconButton
                          color="error"
                          onClick={() => remove(index)}
                          aria-label="delete entity">
                          <Delete />
                        </IconButton>
                      </Grid>
                    )}
                  </Grid>
                </Paper>
              ))}
              {errors.entities?.message && (
                <FormHelperTextP>{errors.entities?.message}</FormHelperTextP>
              )}
              {/* Add Button */}
              <Box sx={{mt: 2}}>
                <Button
                  variant="outlined"
                  onClick={() =>
                    append({
                      entity_id: undefined,
                      entity_completion_type_id: '',
                      entity_completion_sub_type_id: ''
                    })
                  }
                  sx={{
                    textTransform: 'none'
                  }}>
                  + Add
                </Button>
              </Box>
            </Grid>
          )}
          {lockOption === 2 && (
            <Grid item xs={12} md={6}>
              <Controller
                name="lockUntil"
                control={control}
                render={({field, fieldState: {error}}) => {
                  // Convert the string value to Date only if valid
                  const valueAsDate =
                    field.value && isValid(new Date(field.value))
                      ? new Date(field.value)
                      : null;

                  return (
                    <DatePicker
                      {...field}
                      value={valueAsDate}
                      format="dd/MM/yyyy"
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          error: !!error,
                          helperText: error?.message
                        }
                      }}
                    />
                  );
                }}
              />
            </Grid>
          )}

          {/* Save Button */}
          <Grid item xs={12}>
            <Box display="flex" justifyContent="flex-start">
              <LoadingButton
                variant="contained"
                color="primary"
                type="submit"
                loading={isloaded}
                sx={{
                  textTransform: 'none'
                }}>
                Save
              </LoadingButton>
            </Box>
          </Grid>
        </Grid>
      </form>
      <Snackbar
        open={saved}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{vertical: 'top', horizontal: 'center'}}>
        <Alert
          onClose={handleSnackbarClose}
          severity="success"
          sx={{width: '40vw'}}>
          Lock Properties are Updated
        </Alert>
      </Snackbar>
    </LocalizationProvider>
  );
};

export default LockProperties;
